import { render, staticRenderFns } from "./UserViewInfoCardPartTwo.vue?vue&type=template&id=4d6ace68&scoped=true"
import script from "./UserViewInfoCardPartTwo.vue?vue&type=script&lang=js"
export * from "./UserViewInfoCardPartTwo.vue?vue&type=script&lang=js"
import style0 from "./UserViewInfoCardPartTwo.vue?vue&type=style&index=0&id=4d6ace68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6ace68",
  null
  
)

export default component.exports